// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Import environment-specific configs
import devConfig from './config/firebase.dev';
import prodConfig from './config/firebase.prod';

// Select config based on environment (default to prod for safety)
const ENV = process.env.REACT_APP_ENV || 'prod';
const firebaseConfig = ENV === 'dev' ? devConfig : prodConfig;

console.log(`Firebase initialized for: ${ENV} (${firebaseConfig.projectId})`);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

// Expose Firebase instances globally for testing scripts
if (typeof window !== 'undefined') {
  window.db = db;
  window.auth = auth;
  window.app = app;
}

export { app, analytics, db, auth };
